(() => {
  const desktopMedia = window.matchMedia('(min-width: 750px)');
  let frameId = 0;

  const updateCarousel = (carousel) => {
    const track = carousel.querySelector('[data-list-track]');
    if (!track) return;

    const cardCount = track.querySelectorAll('[data-card-index]').length;
    const columns = Number.parseInt(
      getComputedStyle(carousel).getPropertyValue('--dao-video-columns'),
      10
    ) || 1;

    track.classList.toggle(
      'dao-video-carousel__track--centered',
      desktopMedia.matches && cardCount > 0 && cardCount < columns
    );
  };

  const updateAll = (root = document) => {
    if (root.matches?.('dao-video-carousel')) updateCarousel(root);
    root.querySelectorAll?.('dao-video-carousel').forEach(updateCarousel);
  };

  const scheduleUpdate = () => {
    cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(() => updateAll());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
  } else {
    scheduleUpdate();
  }

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  desktopMedia.addEventListener?.('change', scheduleUpdate);
  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
  document.addEventListener('shopify:block:select', scheduleUpdate);
})();
